export const formClasses = {
  outer: '$reset form-group__outer',
  wrapper: '$reset form-group__wrapper',
  label: '$reset form-group__label',
  fieldset: '$reset form-group__fieldset',
  legend: '$reset form-group__legend',
  help: '$reset form-group__help',
  inner: '$reset form-group__inner',
  input: '$reset form-group__input',
  option: '$reset form-group__option',
  options: '$reset form-group__options',
  messages: '$reset formkit-form__messages',
  message: '$reset formkit-form__message',
};

export const appendClasses = (additionalClass: string): Record<string, string> => {
  const entries = Object.entries(formClasses);
  const mapped = entries.map(([key, value]) => [`${key}Class`, `${value} ${additionalClass}`]);
  return Object.fromEntries(mapped);
};
